module.exports = __webpack_public_path__ + "img/snowboard.0e9e7c17.svg";